import { message } from 'antd';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { Container, Button, Modal, Spinner, Card, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Download, Search, ArrowRepeat, Wallet2 } from 'react-bootstrap-icons';
import { reactFormatter } from 'react-tabulator';

import TableView from '../../Components/tableView';
import constants from '../../constants';
import DownloadTransactionForm from '../Transactions/DownloadTransactionForm';
import SyncTransactionForm from '../Transactions/SyncTransactionForm';
import './transactionsList.scss';
import { minMaxFilterEditor, minMaxFilterFunction } from '../../Components/tableViewEditors';
import TrackTransactionForm from '../Transactions/TrackTransactionForm';
import TransactionForm from '../Transactions/transactionForm';
import { useTranslation } from 'react-i18next';
import authAxios from '../../authorization/axios';

interface ITransactionListState {
  refresh: boolean,
  loading: boolean,
  showDetails: boolean,
  selectedTx: any,
  options: any,
  showAlert: boolean,
  showDownloadModal: boolean,
  showTrackModal: boolean,
  fromDate: string,
  toDate: string,
  address: string,
  showSyncModal: boolean,
  filters: { fromDate?: string, toDate?: string },
  totalTransactions: number,
  emptiesTransactions: number
}

/* eslint-disable i18next/no-literal-string */
function Actions(context: any) {
  // eslint-disable-next-line no-underscore-dangle
  const cellData = context.cell._cell.row.data;
  return <>
    <OverlayTrigger
      placement={'bottom'}
      overlay={
        <Tooltip id={'tooltip'}>
          {context.props.t('EXPORT_ORDERS_MODAL_TITLE')}
        </Tooltip>
      }
    >
      <Button size='sm' style={{ marginRight: '1em', background: 'green', color: 'white' }} color='success'
        onClick={() => {
          // eslint-disable-next-line no-underscore-dangle
          context.props.rowSelected({ _row: { data: cellData } });
        }}>
        <Search />
      </Button>
    </OverlayTrigger>
  </>;
}
// message.success({
//   content: context.props.t('EXPORTED_ORDER'),
//   style: {
//     marginTop: 100
//   }
// });
const TransactionList = () => {
  const { t } = useTranslation();
  const [refresh, setRefresh] = useState<ITransactionListState['refresh']>(true);
  const [loading, setLoading] = useState<ITransactionListState['loading']>(false);
  const [showDetails, setShowDetails] = useState<ITransactionListState['showDetails']>(false);
  const [selectedTx, setSelectedTx] = useState<ITransactionListState['selectedTx']>(undefined);
  // eslint-disable-line react/no-unused-state
  const [options] = useState<ITransactionListState['options']>([]);
  const [showAlert, setShowAlert] = useState<ITransactionListState['showAlert']>(false);
  console.log(showAlert);
  const [showDownloadModal, setShowDownloadModal] = useState<ITransactionListState['showDownloadModal']>(false);
  const [showTrackModal, setShowTrackModal] = useState<ITransactionListState['showTrackModal']>(false);
  const [fromDate, setFromDate] = useState<ITransactionListState['fromDate']>('');
  const [toDate, setToDate] = useState<ITransactionListState['toDate']>('');
  // const [filters, setFilters] = useState<ITransactionListState['filters']>({});
  const [address, setAddress] = useState<ITransactionListState['address']>(constants.transaction.address);
  const [showSyncModal, setShowSyncModal] = useState<ITransactionListState['showSyncModal']>(false);
  const [totalTransactions, setTotalTransactions] = useState<ITransactionListState['totalTransactions']>(0);
  const [emptiesTransactions, setEmptiesTransactions] = useState<ITransactionListState['totalTransactions']>(0);



  const refTable = useRef<TableView>(null);

  const getOverviewTransactions = () => {
    return authAxios.get(constants.api.totalTransactions).then((res) => {
      setTotalTransactions(res.data.data?.total || '-');
      setEmptiesTransactions(res.data.data?.empties || '-');
    });
  };

  useEffect(() => {
    getOverviewTransactions();
  }, []);

  const rowSelected = (row: any) => {
    // eslint-disable-next-line no-underscore-dangle
    const rowData = row._row.data;
    setSelectedTx(rowData);
    setShowDetails(true);
    // (this.props as any).history.push({
    //     pathname: `/transactions/${rowData?.tx_id}`
    // });
  };

  const parseBase64 = (cell: any) => {
    const value = cell.getValue();
    if (value) {
      return atob(value);
    }
    return '';
  };

  const copyTxId = (txId: any) => {
    navigator.clipboard.writeText(txId).then(() => {
      message.success({
        content: t('TXID_COPIED'),
        style: {
          marginTop: 60
        }
      });
    });
  };

  const parseCurrency = (cell: any) => {
    const decimals = cell.getRow().getData().unit_decimals;
    const value = cell.getValue();
    if (value) {
      return value / (10 ** decimals);
    }
    return 0;
  };

  const columns = [
    {
      title: t('Date'),
      field: 'date',
      sorter: 'date',
      //headerFilter: 'input',
      headerSortStartingDir: 'desc',
      headerFilter: minMaxFilterEditor,
      headerFilterFunc: minMaxFilterFunction,
      headerFilterLiveFilter: false,
      formatter: (cell: any) => {
        const locale = (window.navigator as any).userLanguage || window.navigator.language;
        return moment(cell.getValue()).locale(locale).format('DD/MM/YYYY HH:mm');
      }
    },
    {
      title: t('TX ID'), field: 'tx_id', sorter: 'string', headerFilter: 'input', cellClick: (e: Event, cell: any) => {
        // alert('cell clicked - ' + cell.getValue());
        copyTxId(cell.getValue());
      }
    },
    { title: t('ORDER_ID'), field: 'internal_order_id', sorter: 'string', headerFilter: 'input' },
    {
      title: t('AMOUNT'),
      field: 'amount',
      sorter: 'string',
      headerFilter: 'input',
      formatter: parseCurrency
    },
    {
      title: t('CURRENCY'),
      field: 'unit_name',
      sorter: 'string',
      headerFilter: 'input'
    },
    { title: t('ORDER_NOTE'), field: 'order_note', sorter: 'string', headerFilter: 'input' },
    { title: t('FROM'), field: 'from', sorter: 'string', headerFilter: 'input' },
    { title: t('TO'), field: 'to', sorter: 'string', headerFilter: 'input' },
    {
      title: t('TX_NOTE'),
      field: 'tx_note',
      sorter: 'string',
      headerFilter: 'input',
      formatter: parseBase64
    },
    {
      title: '',
      width: '100',
      sortable: false,
      formatter: reactFormatter(<Actions props={{ rowSelected: rowSelected.bind(this), t: t }} />),
      headerSort: false
    }
  ];

  const saveTransaction = async (tx: any) => {
    await authAxios.put(constants.api.updateTransaction, tx).then((res) => {
      console.log(res);
      message.success({
        content: t('EXPORTED_ORDER'),
        style: {
          marginTop: 100
        }
      });
    })
      .catch(() => {
        message.error({
          content: t('NOT_EXPORTED_ORDER'),
          style: {
            marginTop: 100
          }
        });
      });

    await getOverviewTransactions();
    setShowDetails(false);
    setShowAlert(true);
    setRefresh(false);
    setRefresh(true);
  };

  const downlaodTrackedTransactionsModal = () => {
    setShowDownloadModal(!showDownloadModal);
  };


  const trackPaymentsModal = () => {
    setShowTrackModal(!showTrackModal);
  };


  const syncTransactionsModal = () => {
    setShowSyncModal(!showSyncModal);
  };

  const changeFromDate = (date: string) => {
    setFromDate(date);
  };

  const changeToDate = (date: string) => {
    setToDate(date);
  };

  const changeAddress = (addrss: string) => {
    setAddress(addrss);
  };

  const trackTransaction = () => {
    setLoading(true);
    authAxios.post(constants.api.trackTransaction, {
      from: fromDate,
      to: toDate,
      address: address
    })
      .then(async (res) => {
        setShowTrackModal(!showTrackModal);
        if (res.data.success) {
          setLoading(false);
          message.success({
            content: `${res.data.data.txs_added} ${t('TRANSACTIONS_UPDATE')}`,
            duration: 2,
            style: {
              marginTop: 50,
              width: 'auto'
            }
          });
          refTable.current?.reloadData();
          await getOverviewTransactions();
        }
      })
      .catch((reason: any) => {
        console.log(reason);
      });
  };

  const downloadTransaction = () => {
    authAxios.post(constants.api.exportTransaction, {
      from: fromDate,
      to: toDate
    }).then((res: any) => {
      if (res.data?.success) {
        const a = document.createElement('a');
        a.href = `data:${res.data.data.mime};base64,${res.data.data.base64}`;
        a.download = `${res.data.data.filename}`;
        a.click();
      }
    });
  };
  /* unused
    const clearFilters = () => {
      setState({ ...state, filters: {} });
    };
  */
  return (
    <>
      <Card id='txs-filters' style={{ marginLeft: '0.5em', marginRight: '0.5em' }}>
        <Card.Body>
          <Row>
            <Col>
              <div>
                <b>{t('TOTAL').toUpperCase()}</b>: {totalTransactions}
                <br></br>
                <b>{t('NO_ASSOCIATE').toUpperCase()}</b>: {emptiesTransactions}
              </div>
            </Col>
            <Col>
              <div className='text-right'>
                <OverlayTrigger
                  placement={'bottom'}
                  overlay={
                    <Tooltip id={'tooltip'}>
                      {t('DOWNLOAD_TRANSACTION')}
                    </Tooltip>
                  }
                >
                  <Button style={{ color: 'white' }} className="botton-hover" variant='primary' onClick={downlaodTrackedTransactionsModal}>
                    <Download />
                  </Button>
                </OverlayTrigger>
                <OverlayTrigger
                  placement={'bottom'}
                  overlay={
                    <Tooltip id={'tooltip'}>
                      {t('TRACK_PAYMENT')}
                    </Tooltip>
                  }
                >
                  <Button className="botton-hover" variant='primary' style={{ marginLeft: 20,  color: 'white'  }}
                  onClick={trackPaymentsModal}>
                    <Wallet2 />
                  </Button>
                </OverlayTrigger>
                <OverlayTrigger
                  placement={'bottom'}
                  overlay={
                    <Tooltip id={'tooltip'}>
                      {t('SYNCHRONIZE_TRANSACATIONS')}
                    </Tooltip>
                  }
                >
                  <Button  className="botton-hover" variant='primary' style={{ marginLeft: 20,  color: 'white'  }}
                  onClick={syncTransactionsModal}>
                    <ArrowRepeat />
                  </Button>
                </OverlayTrigger>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>


      <Container fluid>
        {
          refresh &&
          <TableView
            t={t}
            ref={refTable}
            api={constants.api.getTransactions}
            columns={columns}
            id={'transactions'}
            initialSorting={[{ column: 'date', dir: 'desc' }]}
          />
        }

        <Modal
          show={showDetails}
          onHide={() => setShowDetails(false)}
          backdrop='static'
          keyboard={false} size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('EXPORT_ORDERS_MODAL_TITLE')}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <TransactionForm
              tx={selectedTx}
              t={t}
              isLoading={false}
              options={options}
              onValueChange={(tx: any) => setSelectedTx(tx)}
            />
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant='secondary'
              onClick={() => setShowDetails(false)}
            >
              {t('CANCEL')}
            </Button>
            <Button variant='primary' onClick={() => saveTransaction(selectedTx)}>
              {t('SAVE')}
            </Button>
          </Modal.Footer>
        </Modal>
        {loading && <div className='fullscreen backdrop'>
          <Spinner animation='border' role='status' variant={'light'}>
            <span className='sr-only'>{t('LOADING')}...</span>
          </Spinner>
        </div>}
        <Modal
          show={showDownloadModal}
          onHide={() => setShowDownloadModal(false)}
          keyboard={false} size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('DOWNLOAD_TRANSACTION')}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <DownloadTransactionForm
              changeFromDate={(date: string) => changeFromDate(date)}
              changeToDate={(date: string) => changeToDate(date)}
              fromDate={fromDate}
              toDate={toDate} />
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant='secondary'
              onClick={() => setShowDownloadModal(false)}
            >
              {t('CANCEL')}
            </Button>
            <Button variant='primary' onClick={() => downloadTransaction()}>
              {t('SAVE')}
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showTrackModal}
          onHide={() => setShowTrackModal(false)}
          keyboard={false} size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('TRACK_PAYMENT')}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <TrackTransactionForm
              t={t}
              changeFromDate={(date: string) => changeFromDate(date)}
              changeToDate={(date: string) => changeToDate(date)}
              changeAddress={(addrss: string) => changeAddress(addrss)}
              fromDate={fromDate}
              toDate={toDate}
              address={address} />
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant='secondary'
              onClick={() => setShowTrackModal(false)}
            >
              {t('CANCEL')}
            </Button>
            <Button variant='primary'
              onClick={() => {
                setLoading(true);
                trackTransaction();
              }
              }>
              {t('SAVE')}
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showSyncModal}
          onHide={() => setShowSyncModal(false)}
          keyboard={false} size='xl'
        >
          <SyncTransactionForm
            refreshPage={() => setRefresh(true)}
            showSyncModal={showSyncModal}
            onComplete={async () => {
              setShowSyncModal(false);
              await getOverviewTransactions();
            }} />
        </Modal>
      </Container>
    </>
  );
};

export default TransactionList;